export default "__VITE_ASSET__wfu2J0ni__"